import withTextSearch from '@components/blog/data/withTextSearch'
import Icon from '@components/shared/Icon'
import ButtonSpinner from '@components/spinner/ButtonSpinner'
import useT from '@hooks/useTranslation'

import styles from '@components/blog/styles/PostSimpleWidget.module.css'

function PostSearchSimpleWidget ({ loading, value, onChange }) {
    return (
        <div className={styles.input}>
            <label htmlFor="index">{useT('Skorowidz')}</label>
            <input id="index" type="text" value={value} onChange={onChange} />
            <span className={styles.icon}>
                {
                    loading
                        ? <ButtonSpinner />
                        : <Icon>search</Icon>
                }
            </span>
        </div>
    )
}

export default withTextSearch (PostSearchSimpleWidget)